import { artworkChargeConstants } from "../../constants";

export function artworkCharges(state = {}, action) {
  switch (action.type) {
    // get all
    case artworkChargeConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case artworkChargeConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case artworkChargeConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case artworkChargeConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case artworkChargeConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case artworkChargeConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case artworkChargeConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case artworkChargeConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case artworkChargeConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case artworkChargeConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case artworkChargeConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case artworkChargeConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case artworkChargeConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
